import { useTexts } from '@/contexts/LanguageContext'
import { useTrustCenterConfig } from '@/contexts/TrustCenterContext'
import { QALEA_ENS_CERTIFICATE_URL, QALEA_ENS_HIGH_LOGO_SRC } from '@/lib/constants/qaleaTrustCenter'
import { isTrustCenterStandardName, STANDARD_ENS, STANDARD_IMAGES, STANDARD_NAMES } from '@/lib/constants/standards'
import S from '@/settings'

export interface ICertification {
  standard: string
  name: string
  description: string
  summary: string
  logo: string
  certificateUrl?: string
}

export function useCertifications(): ICertification[] {
  const { DESCRIPTIONS, SUMMARIES } = useTexts().PUBLIC_TRUST_CENTER.CERTIFICATIONS
  const { standards, organizationName } = useTrustCenterConfig()
  const isQalea = organizationName === S.QALEA_ORGANIZATION_NAME
  return standards.filter(isTrustCenterStandardName).map((standard) => {
    const isQaleaENS = isQalea && standard === STANDARD_ENS
    return {
      standard,
      name: STANDARD_NAMES[standard],
      description: DESCRIPTIONS[standard],
      summary: SUMMARIES[standard],
      logo: isQaleaENS ? QALEA_ENS_HIGH_LOGO_SRC : STANDARD_IMAGES[standard],
      certificateUrl: isQaleaENS ? QALEA_ENS_CERTIFICATE_URL : undefined,
    }
  })
}
